export default class TicketTemplateCreateController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');
        this.api = this.injector.get('$http');
        this.state = this.injector.get('$state');
        this.acl = this.injector.get('Acl');

        this.loading = true;
        this.submitting = false;

        this.availableTemplateTypes = [];

        this._loadAvailableTemplateTypes();
    }

    createTemplate(templateType) {
        this.submitting = true;
        this.api
            .post('tickets/templates/from-template-type', {
                template_type_id: templateType.id
            })
            .then(({data}) => {
                this.submitting = false;
                this.alert.success(
                    this.translate.instant('general.alerts.create_success.title'),
                    this.translate.instant('general.alerts.create_success.content')
                );

                this.state.go('app.tickets.templates.edit', {
                    id: data.data.id
                });
            })
            .catch(e => {
                this.alert.handle(e)
                this.submitting = false;
            });
    }

    createCustomTemplate() {
        if (!this.acl.hasRight('tickets::templates-create-custom')) {
            this.alert.animatedAlert(
                this.translate.instant('tickets.templates.pages.create.custom_not_enabled.title'),
                this.translate.instant('tickets.templates.pages.create.custom_not_enabled.content'),
                'attention',
                {
                    showCancelButton: false,
                    confirmButtonText: this.translate.instant('general.buttons.ok')
                }
            );
            return;
        }
        this.submitting = true;
        this.api.post('tickets/templates/custom')
            .then(({data}) => {
                this.submitting = false;
                this.alert.success(
                    this.translate.instant('general.alerts.create_success.title'),
                    this.translate.instant('general.alerts.create_success.content')
                );

                this.state.go('app.tickets.templates.edit', {
                    id: data.data.id
                });
            })
            .catch(e => {
                this.alert.handle(e)
                this.submitting = false;
            });
    }

    _loadAvailableTemplateTypes() {
        this.api
            .get(`tickets/templates/types`)
            .then(({data}) => {
                this.availableTemplateTypes = data.data;
                this.loading = false;
            })
            .catch((e) => {
                this.alert.handle(e);
                this.state.go('app.tickets.templates.index')
            })
    }
}

TicketTemplateCreateController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/tickets/templates/controllers/pages/create-controller.js